<!--
  @Description 单个菜单修改天数设置
  @Date 2022-09-08
  @Author 刘福
-->
<template>
  <div>
    <el-form ref="elForm" label-position="left" :model="form" :rules="rules">
      <el-row>
        <el-col :span="8">
          <el-form-item label="天数" prop="days">
            <el-input v-model="form.days" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'menuModifyDaySetting',
  data() {
    return {
      // 数据
      form: {
        days: 0
      },
      // 校验规则
      rules: {
        days: [
          { required: true, message: '请输入天数', trigger: 'change' },
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ]
      },
    }
  },
  created() {
    this.BindText()
  },
  methods: {
    async BindText() {
      const { data: res } = await this.$http.get('/Bugs/YKBug/limit-days')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
      }
      this.form.days = res.data
    },
    // 修改
    async updateData() {
      const that = this
      this.$refs.elForm.validate((valid) => {
        if (valid) {
          that.httpUpdate()
        } else {
          this.$message.error('数据校验失败，请输入正确数据')
        }
      })
    },
    // 发起修改请求
    async httpUpdate() {
      const { data: res } = await this.$http.put(`/Bugs/YKBug/limit-days/${this.form.days}`)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.BindText()
    },
  },
  computed: {
  }
}
</script>

<style lang="less">
// 工具栏高度调整
.vxe-toolbar.size--mini {
  display: flex;
  align-items: flex-start;
  height: 40px;
}
</style>
